import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomAddress } from "./address";

import type { StandardRoomI18nCategoriesAndManagerStore } from "../../_store/categories";

type Props = {
	address: StandardRoomI18nCategoriesAndManagerStore["address"];
};

export const QuestionRoomI18nAddressRoot = ({ address }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={address}>
			<QuestionRoomAddress />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomI18nAddressRoot.displayName = "QuestionRoomI18nAddressRoot";
